import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const TrackingInformation = styled.div`
	.alert {
		margin-bottom: 1rem;

		.ticketInProgress {
			display: flex;
			align-items: center;
			overflow: visible;
			padding: 1rem 0;
		}

		@media ${Breakpoints.mobile} {
			margin-bottom: 2rem;
		}
	}

	@media ${Breakpoints.mobile} {
		padding: 2rem;
	}
`;

export const TimeStatusWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;
	padding: 3rem 1rem;
	align-items: center;
	justify-content: space-between;
	width: 100%;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: start;
		padding: 1rem 0;
	}
	span {
		width: 100%;
	}
`;

export const ShipmentStatusWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;
	padding: 3rem 1rem;
	align-items: center;
	justify-content: space-between;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: start;
		gap: 0;

		padding: 1rem 0;
	}
`;

export const TimeStatus = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: start;
	justify-content: start;
	max-width: 20%;
	@media ${Breakpoints.mobile} {
		max-width: 100%;
	}
`;

export const TimeStatusHeader = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
	margin-bottom: 1rem;
	width: 100%;

	body[dir='rtl'] & {
		margin-bottom: unset;
	}
`;
export const DCWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: start;
	gap: 0.5rem;

	img {
		width: 5.2rem !important;
		height: 5.2rem !important;
	}
`;
export const DCText = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	gap: 1.2rem;

	& > :nth-child(2) {
		cursor: pointer;
	}
	@media ${Breakpoints.mobile} {
		padding: unset;
		gap: 0.75rem;
	}

	body[dir='rtl'] & {
		gap: 0.5rem;
	}
`;

export const Line = styled.span`
	height: 1px;
	min-height: 1px;
	background-color: var(--border-color);
	width: 100%;
	display: block;

	&.bottomLine {
		margin-bottom: 3rem;
	}

	@media ${Breakpoints.mobile} {
		margin: 2rem 0;
	}
`;

export const ShipmentStatus = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;

	&.filter {
		filter: grayscale(100%);
	}

	@media ${Breakpoints.mobile} {
		flex-direction: row;
	}
`;

export const ShipmentStatusText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;

	@media ${Breakpoints.mobile} {
		align-items: start;
	}
`;
export const ShipmentStatusDateWrapper = styled.div`
	display: flex;
	gap: 0.5rem;
`;

export const DashedLine = styled.div`
	width: 100%;
	height: 1px;
	margin-bottom: 5rem;
	border-top: 2px dashed var(--blue);

	@media ${Breakpoints.mobile} {
		width: 1px;
		height: 30px;
		margin-bottom: unset;
		margin-left: 3rem;
		border-top: none;

		border-left: 2px dashed var(--blue);

		body[dir='rtl'] & {
			margin-left: unset;
			margin-right: 3rem;
		}
	}

	&.filter {
		filter: grayscale(100%);
	}
`;

export const AccordionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

export const AccordionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	&.expanded {
		svg {
			transform: scale(1, -1);
		}
	}
`;
